<template>
	<div class="status">
		<b-card no-body class="p-3" v-loading="is_loading">
			<b-row>
				<b-col cols="12" md="4">
					<h4>Loan Information</h4>
					<div class="d-flex align-items-center">
						<h3 class="display-4 text-primary" @click="navigateToCard('card_loan_information')"
							style="cursor: pointer;">
							{{ _gHlp.getValue(credit_report_summary,'total_issues.loan_information',0) }}
						</h3>
						<small class="ml-1">Issues</small>
					</div>
				</b-col>
				<b-col cols="12" md="4" class="border-right border-left">
					<h4>Missed Payment History</h4>
					<div class="d-flex align-items-center">
						<h3 class="display-4 text-primary" @click="navigateToCard('card_missed_payment_history')"
							style="cursor: pointer;">
							{{ _gHlp.getValue(credit_report_summary,'total_issues.missed_payment',0) }}
						</h3>
						<small class="ml-1">Issues</small>
					</div>
				</b-col>
				<b-col cols="12" md="4">
					<h4>SAA</h4>
					<div class="d-flex align-items-center">
						<h3 class="display-4 text-primary" @click="navigateToCard('card_special_attention')"
							style="cursor: pointer;">
							{{ _gHlp.getValue(credit_report_summary,'total_issues.special_attension',0) }}
						</h3>
						<small class="ml-1">Issues</small>
					</div>
				</b-col>
			</b-row>
		</b-card>
	</div>
</template>
<script>
export default {
	name: 'commitment',
	props: ['credit_report_summary'],
	components: {		
	},
	data() {
		return {
		}
	},
	computed: {
		is_loading(){
			return _gHlp.isLoading('fetch_credit_report') || _gHlp.isLoading('fetch_loan_ec') || _gHlp.isLoading('fetch_customer')
		}
	},
	methods: {
		navigateToCard(card) {
			this.$emit('goSection',card);
		}
	}
}
</script>